(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["4t1-product-navigation"] && !Shopify.designMode) return;
  try {
    const navigation = document.querySelector('[data-four-t-product-nav]');
if (navigation && document.referrer) {
  try {
    const source = new URL(document.referrer);
    const allowed = JSON.parse(navigation.querySelector('[data-four-t-collections]').textContent);
    const match = allowed.find(item => item.url.replace(/\/$/, '') === source.pathname.replace(/\/$/, ''));
    if (source.origin === window.location.origin && match) {
      navigation.querySelector('[data-four-t-return]').href = source.href;
      const crumb = navigation.querySelector('[data-four-t-collection]');
      crumb.href = source.href;
      crumb.textContent = match.title;
    }
  } catch {}
}
  } catch(e) { console.error(e); }
})();

})();
